import React, { JSX } from 'react';
import { Amplify } from 'aws-amplify';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import store from './redux/store';
import Loading from './components/Loading';
import { SidebarProvider } from './hooks/useSidebar';
import Routers from './route';
import 'dayjs';
import 'dayjs/locale/pt-br';
import 'react-toastify/dist/ReactToastify.min.css';
import './styles/global.css';
import { LoginCallerProvider } from './hooks/useLoginCaller';
import awsExports from './aws-exports';

Amplify.configure(awsExports);

const App: React.FC = (): JSX.Element => (
  <Provider store={store}>
    <Loading />
    <LoginCallerProvider>
      <SidebarProvider>
        <Routers />
      </SidebarProvider>
    </LoginCallerProvider>
    <ToastContainer />
  </Provider>
);

export default App;
